import * as actionTypes from './action-types';

export const checkUserIsAuthorized = () => ({
    type: actionTypes.CHECK_USER_IS_AUTHORIZED_REQUEST
});

export const checkUserIsAuthorizedSuccess = payload => ({
    type: actionTypes.CHECK_USER_IS_AUTHORIZED_SUCCEED,
    payload
});

export const checkUserIsAuthorizedFailure = () => ({
    type: actionTypes.CHECK_USER_IS_AUTHORIZED_FAILURE
});

export const setAlertModalStatus = displayModalStatus => ({
    type: actionTypes.ALERT_MODAL_DISPLAY_STATUS,
    displayModalStatus
});



// WEBPACK FOOTER //
// ./app/components/with-auth/actions.js